import { Container, WrapperSteps } from './styles'
import React, { useState } from 'react'
import { Step, useMenu } from '../../../contexts/MenuContext'
import { AlertBox } from '../../../assets/styledComponents/AlertBox'
import { validationTexts } from '../../../assets/constants/validationTexts'
import PropTypes from 'prop-types'
import { Stage } from '../../molecules/Stage'
import { TAGLogoLink } from '../../molecules/TAGLogoLink'

export function StagesMenu( { menuJustification } ) {
  const { steps, activeStep, setActiveStep, setSelectedIndex } = useMenu()
  const [ displayAlertBox, setDisplayAlertBox ] = useState( false )

  const handleClick = ( index ) => {
    if ( index !== 0 && !steps[ 0 ].completed ) {
      setDisplayAlertBox( true )
    } else if ( activeStep !== index ) {
      const isStepAllowed = index === 0 || steps[ index - 1 ].completed

      if ( activeStep === Step.CHOOSE_BOX ) {
        setActiveStep( isStepAllowed ? index : 1, { 'navigation': true } )
      } else if ( index < activeStep ) {
        setActiveStep( index, { 'navigation': true } )
      } else {
        setSelectedIndex( isStepAllowed ? index : activeStep + 1 )
      }
    }
  }

  return (
    <>
      <Container
        justification={ menuJustification }
        selectedIndex={ activeStep }
      >
        <TAGLogoLink />
        <WrapperSteps className="menu__wrapper-steps">
          {steps.map( ( step, index ) => {
            if ( step.label !== 'Assinatura concluída' && step.label !== 'Pix confirmado' ) {
              return (
                <Stage
                  active={ activeStep === index }
                  completed={ step.completed }
                  key={ step.label }
                  number={ index + 1 }
                  onClick={ () => handleClick( index ) }
                >{ step.label }
                </Stage>
              )
            } else {
              return ''
            }
          } ) }
        </WrapperSteps>
      </Container>
      {displayAlertBox && <AlertBox type="error">{ validationTexts.STEP_ONE_FORWARD_ERROR_MESSAGE }</AlertBox>}
    </>
  )
}

StagesMenu.propTypes = {
  'menuJustification': PropTypes.string
}

StagesMenu.defaultProps = {
  'menuJustification': ''
}
